import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Progress } from "../../lib";

import BgColor from "../../components/Reader/BgColor";
import Tools from "../../components/Reader/Tools";
import Toolbar from "../../components/Reader/Toolbar";
import TableOfContents from "../../components/Reader/TableOfContents";
import PageContents from "../../components/Reader/PageContents";
import Preview from "../../components/Reader/Preview";

import { Books } from "../../models";
import { device } from "../../helpers";
import { ReaderDoc } from "../../components/Reader";
import { Page } from "../BookPage/TableOfContents";
import { AxiosResponse } from "axios";
import { AppState } from "../../store";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    @media ${device.phone} {
        padding-bottom: 50px;
    }
`;

const mapStateToProps = (
    _: AppState,
    {
        match: {
            params: { doc_id, page_id },
        },
    }: OwnProps
) => ({
    doc_id: parseInt(doc_id),
    page_id: parseInt(page_id),
});
type StateProps = ReturnType<typeof mapStateToProps>;

type OwnProps = {
    doc_id: number;
    page_id: number;
    match: {
        params: {
            doc_id: string;
            page_id: string;
        };
    };
};
type Props = StateProps & OwnProps;
type State = {
    loaded: boolean;
    doc: ReaderDoc | null;
    pages: Array<Page> | null;
};

class ReaderPage extends React.Component<Props, State> {
    static paths = [
        "/app/r-:doc_id-:page_id/",
        "/app/r-:doc_id-:page_id/:doc_name/:page_name",
        "/app/r-:doc_id-:page_id/:slug",
    ];
    static requiresAuth = false;

    constructor(props: Props) {
        super(props);
        this.fetchDoc = this.fetchDoc.bind(this);

        this.state = {
            loaded: false,
            doc: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.fetchDoc();
    }

    fetchDoc = async () => {
        try {
            const { doc_id } = this.props;
            const { data: doc }: AxiosResponse<ReaderDoc> = await Books.fetch(
                doc_id
            );
            this.setState({ doc, loaded: true });
        } catch (e) {
            console.warn("failed fetchDoc");
            console.warn(e);
        }
    };

    render() {
        if (!this.state.loaded) {
            return <Progress />;
        }

        const { doc_id, page_id } = this.props;
        const { doc } = this.state;

        if (!doc) {
            return null;
        }

        const props = {
            doc_id,
            page_id,
            doc,
        };

        return (
            <Container>
                <BgColor />
                <Toolbar {...props} />
                <TableOfContents {...props} />
                <Tools {...props} />
                <Preview />
                <PageContents {...props} />
            </Container>
        );
    }
}

export default connect(mapStateToProps)(ReaderPage);
